import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'components/ui/table';
import { User } from 'types/common_types';
import Text from 'components/Text';
import { cn } from 'lib/utils';
import { delete_icon, edit_icon } from 'asset/icons';
import { ReactSVG } from 'react-svg';

interface UserTableProps {
  users: User[];
  onEdit?: (user: User) => void;
  onDeactivate?: (user: User) => void;
}

const UserTable = ({ users, onEdit, onDeactivate }: UserTableProps) => {
  return (
    <div className='min-h-0'>
      <div className='rounded-xl border max-h-full overflow-y-auto'>
        <Table>
          <TableHeader className='!sticky top-0 z-10 bg-white'>
            <TableRow className='hover:bg-transparent'>
              <TableHead className='text-black px-4 py-3 min-w-32'>User Name</TableHead>
              <TableHead className='text-black min-w-40'>Email</TableHead>
              <TableHead className='text-black min-w-24'>Role</TableHead>
              <TableHead className='text-black min-w-44'>Assigned Audits count</TableHead>
              <TableHead className='text-black min-w-24'>Status</TableHead>
              <TableHead className='text-black min-w-36'>Action</TableHead>
            </TableRow>
          </TableHeader>

          <TableBody>
            {users?.map((user, index) => (
              <TableRow key={index} className='hover:bg-muted/50'>
                <TableCell className='px-4 py-3'>
                  <Text text={user?.fullName} className='text-muted-foreground' />
                </TableCell>

                <TableCell>
                  <Text text={user?.email} className='text-muted-foreground' />
                </TableCell>

                <TableCell>
                  <Text text={user?.role} className='text-muted-foreground' />
                </TableCell>

                <TableCell>
                  <Text text={user?.assignedAuditsCount ?? '-'} className='text-muted-foreground' />
                </TableCell>

                <TableCell>
                  <span
                    className={cn(
                      'inline-flex items-center px-3 py-1 rounded-full text-xs font-medium',
                      user?.status === 'Active' ? 'bg-primary text-white' : 'bg-primary/20 text-primary',
                    )}
                  >
                    {user?.status}
                  </span>
                </TableCell>

                <TableCell>
                  <div className='flex gap-4'>
                    <div className='flex items-center gap-1 text-muted-foreground hover:text-black cursor-pointer' onClick={() => onEdit?.(user)}>
                      <Text text='Edit' className='text-muted-foreground' />
                      <ReactSVG src={edit_icon} />
                    </div>

                      <div
                      className='flex items-center gap-1 cursor-pointer text-destructive hover:text-destructive'
                      onClick={() => onDeactivate?.(user)}
                    >
                      <Text text={user?.status==='Active' ? 'Deactivate' : 'Activate'} className='text-destructive' />
                    </div>

                   

                    
                  </div>
                </TableCell>
              </TableRow>
            ))}

            {(users?.length === 0 || !users) && (
              <TableRow>
                <TableCell colSpan={6} className='py-10 text-center'>
                  <Text text='No users found.' className='text-muted-foreground' />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default UserTable;
